 
  const win: any = window;
  const shareObj = {
    title: 'IPO新规将至，哪些新股有赚钱机会！',
    content: '同花顺分享'
  }
 // 分享函数
  export const callShare = () => {
    // 分享出去参数去掉
    let url = window.location.href;
    // 公司概况分享埋点需要加上fromshare
    url = url.indexOf('?') > -1 ? url.replace('?', '?fromshare=1&') : url + '?fromshare=1';
    const param = {
      type: '1',
      title: '',
      content: '',
      url,
      bmpRes: '3',
      actionKey: '1',
    };
    const opt = Object.assign(param, shareObj);

    win.callNativeHandler('hexinShare', JSON.stringify(opt), () => {
      return;
    });
  }




/**
 * 分时简况下基于当前地址调用分享协议分享(地址分享卡片形式)
 * @export
 * @param {string} title 分享卡片名
 * @param {string} content 分享卡片介绍
 * @param {string} [url] 分享的地址（默认当前地址）
 */
 export function shareUrlCard() {
    // 微信二次分享授权
    if (!win.F10Utils.getBroker() && win.F10Utils.getUrlParams('fromshare')) {
      win.F10Utils.loadScript("//s.thsi.cn/js/m/v2.11/common/wxShare.js", () => {
        win.wxShare.init(
            {
              title: shareObj.title,
              desc: shareObj.content,
            },
            {
              trigger: (data: any) => {return;},
              success: (data: any) => {return;},
              cancel: (data: any) => {return;},
              fail: (data: any) => {return;},
            }
        )
      });
    }
    win.callNativeHandler("changeWebViewButton", "");
    win.registerWebHandler("changeWebViewButton", (data: any) => {
        callShare();
    }) 
 }